import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom"; // ✅ Importamos useNavigate y Link
import "../styles/avisos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../img/logoAmnorte.png";
import emailjs from "emailjs-com";


const NavBar = () => {
  const navigate = useNavigate(); // ✅ Hook para navegación

  const [navbarColor, setNavbarColor] = useState("#354a66");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const carouselElement = document.getElementById("main-carousel");
      const carouselHeight = carouselElement ? carouselElement.clientHeight : 500;

      if (scrollY < carouselHeight / 2) {
        setNavbarColor("#354a66");
      } else {
        setNavbarColor("#354a66");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" style={{ background: navbarColor, transition: "background 0.3s ease-in-out" }} fixed="top" className="navbar-custom">
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ color: "#fff" }}>
          <img src={logo} alt="Logo Aceros y Metales" height="50" className="me-2" />
          <span>Aceros y Metales</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNav" />

      </Container>
    </Navbar>
  );
};

const ContactForm = () => {


  return (
    <div>
      <div class="servicios-container">
        <div class="servicios-title">
          Avisos de Privacidad
        </div>
      </div>

      <div class="terminos">
        <p style={{ textAlign: 'justify' }}>
          A los Usuarios (como se definen posteriormente), les informamos que el siguiente Aviso de Privacidad, les es
          aplicable por el simple uso o acceso a cualquiera de las páginas, aplicaciones web y móviles, softwares y,
          aplicaciones en general, que integran el Portal de www.aymdelnorte.com.mx (en adelante y, conjunta e
          indistintamente, el "Portal"), por lo que entenderemos que lo acepta y acuerda en obligarse en su
          cumplimiento. <strong>En caso de que no esté de acuerdo con el Aviso de Privacidad y/o con los Términos y
            Condiciones a su
            disposición, deberá abstenerse de acceder o utilizar el Portal.</strong>
        </p>
        <p style={{ textAlign: 'justify' }}>
          El Usuario, entendido como aquella persona que realiza el uso o accede, mediante equipo de cómputo y/o
          cualquier equipo de comunicación o dispositivo, al Portal (en adelante el “Usuario”), acepta plena y sin
          reserva todas y cada una de las disposiciones incluidas en el presente Aviso de Privacidad.
        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>RESPONSABLE DEL TRATAMIENTO DE SUS DATOS PERSONALES.</strong> Para Comercializadora Fuerte Grande
          del
          Norte, SAPI de CV (en adelante la "Empresa") la seguridad de los Usuarios es nuestra prioridad, por lo que
          protegemos sus datos personales mediante el uso, aplicación y mantenimiento de altas medidas de seguridad
          técnicas, físicas y administrativas.
        </p>

        <p style={{ textAlign: 'justify' }}>
          Como Usuario, usted tiene la oportunidad de escoger entre una amplia gama de productos y servicios a través
          de nuestro Portal, sabiendo que sus datos personales estarán protegidos y serán tratados de manera
          confidencial. Les informamos que el RESPONSABLE de recabar y dar tratamiento y/o utilizar los datos
          personales que el Usuario proporcione a través del Portal, es la Empresa, así como sus subsidiarias,
          asociadas, sociedades controladoras y
          afiliadas.

        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>DOMICILIO DEL RESPONSABLE.</strong> Para efectos del presente aviso de privacidad, la Empresa
          señala,
          individualmente, como su domicilio, el ubicado en Baja California 274 int. P2 INT2, Hipodromo, Cuauhtémoc,
          Ciudad de México, C. P. 06100

        </p>

        <p style={{ textAlign: 'justify' }}>
          <strong>DATOS PERSONALES QUE PUEDEN SER RECOLECTADOS.</strong> Los datos personales que la Empresa puede
          recopilar del Usuario al utilizar el Portal y/o contratar nuestros servicios y productos, son los
          siguientes:
          <p><strong>I.</strong> Nombre, Telefono, Correo Electronico</p>

        </p>

        <p style={{ textAlign: 'justify' }}>
          <strong>FINALIDADES DEL TRATAMIENTO DE SUS DATOS PERSONALES.</strong> Los datos personales que la Empresa
          recabe serán utilizados para atender las siguientes finalidades:
        </p>

        <p style={{ textAlign: 'justify' }}>

        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>I.</strong> Autentificar identidad, Informar sobre cambios, nuevos productos y servicios que estén
          relacionado con lo
          contratado por los Clientes o Proveedores de la Empresa

        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>II.</strong> Para integrar expedientes, bases de datos y sistemas necesarios para llevar a cabo las
          operaciones y
          servicios correspondientes; (ii) Para reclamar la entrega de premios y/o promociones; (iii) Para llevar a
          cabo análisis
          internos;

        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>III.</strong> De manera adicional, se podrán utilizar sus datos personales para las siguientes
          finalidades
          secundarias: (i) Mercadotecnia, publicidad y prospección comercial; (ii) Ofrecerle, en su caso, otros
          productos y servicios propios de la Empresa o de cualquiera de sus afiliadas, subsidiarias, sociedades
          controladoras, asociadas, comisionistas o sociedades; (iii) Remitirle promociones de otros bienes, servicios
          y/o productos; (iv) Para realizar análisis
          estadísticos, de generación de modelos de información y/o perfiles de comportamiento actual y predictivo y,
          (v) Para participar en encuestas, sorteos y promociones.

        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>OPCIONES Y MEDIOS PARA LIMITAR EL USO O DIVULGACIÓN DE LOS DATOS.</strong> La Empresa tiene
          implementadas medidas de seguridad administrativas, técnicas y físicas para proteger sus datos personales,
          mismas que igualmente exigimos sean cumplidas por los proveedores de servicios que contratamos. Usted podrá
          limitar el uso O divulgación de sus datos personales enviando un correo electrónico a
          contacto@aymdelnorte.com.mx indicándonos en el cuerpo del correo su nombre completo y que dato desea que no
          sea divulgado, de proceder su solicitud, se le registrará en el listado de exclusión.

        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>MEDIOS PARA EJERCER LOS DERECHOS DE ACCESO, RECTIFICACIÓN, CANCELACIÓN U OPOSICIÓN
            (DERECHOS ARCO).</strong> Puede enviar un correo electrónico a contacto@aymdelnorte.com.mx, en cualquier
          momento, para ejercer sus Derechos de Acceso, Rectificación, Cancelación u Oposición (“Derechos ARCO”). Para
          ejercer los Derechos ARCO, usted (o su representante legal), deberá presentar la solicitud, identificándose
          con la siguientedocumentación:

        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>I.</strong> Nombre del usuario o titular
        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>II.</strong> Domicilio del usuario o titular u otro medio para comunicarle la respuesta a su
          solicitud.

        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>III.</strong> Documentos que acrediten su identidad (IFE/INE pasaporte) y, en su caso, los
          documentos que acrediten la representación legal del solicitante.

        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>IV.</strong> Una descripción de la información / los datos sobre los que está tratando de ejercer
          sus derechos ARCO y los derechos que le gustaría ejercer.

        </p>
        <p style={{ textAlign: 'justify' }}>
          Si uno o más de los documentos mencionados anteriormente no están incluidos, y/o los documentos tienen
          errores u omisiones, la Empresa le notificará dentro de los 3 días hábiles posteriores a la recepción de la
          solicitud y le pedirá los documentos faltantes y/o las correcciones pertinentes; tendrá 5 días hábiles a
          partir de esa notificación para
          proporcionar la información actualizada, de lo contrario, la solicitud se entenderá como no presentada.
        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>TRANSFERENCIA DE DATOS PERSONALES. </strong>La Empresa podrá divulgar sus datos personales a
          aquellos terceros que, en virtud de los servicios y productos ofrecidos, necesiten conocerlos para cumplir
          cabalmente con los mismos.
        </p>
        <p style={{ textAlign: 'justify' }}>
          Asimismo, la Empresa puede divulgar su información a las autoridades competentes en términos de la
          legislación aplicable; cualquier transferencia de sus datos personales sin consentimiento se realizará de
          acuerdo con el Artículo
          37 de la LFPDPPP.
        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>WEB BEACONS. </strong>La Empresa, podrá o no, utilizar tecnologías de seguimiento tales como web
          beacons, similares a las cookies, para recabar datos sobre sus visitas en el Portal; éstas son pequeñas
          imágenes electrónicas incrustadas en el contenido web o mensajes de correo electrónico, las cuales no
          se encuentran normalmente visibles para los Usuarios y que nos permiten generar contenidos casi
          personalizados para ofrecerle una mejor experiencia cuando utilice nuestro Portal.

        </p>
        <p style={{ textAlign: 'justify' }}>
          En caso de no estar de acuerdo con cualquiera de las condiciones aquí establecidas, el Usuario siempre podrá
          cambiar la configuración de su navegador.
        </p>
        <p style={{ textAlign: 'justify' }}>
          <strong>MODIFICACIONES AL AVISO DE PRIVACIDAD.</strong> El presente aviso de privacidad puede sufrir
          modificaciones, cambios o actualizaciones derivadas, entre otras cosas, por nuevos requerimientos legales;
          necesidades propias de la Empresa, por los productos o servicios que ofrecemos; por nuestras prácticas de
          privacidad; por cambios en nuestro modelo de negocio, o por otras causas.

        </p>

        <p style={{ textAlign: 'justify' }}>
          Cualquier modificación al presente aviso de privacidad le será notificada a través de cualquiera de los
          siguientes medios: un comunicado por escrito enviado a su domicilio; por el correo electrónico que señale;
          un mensaje a su teléfono móvil; un mensaje dado a conocer a través del Portal o de cualquier medio
          electrónico que utilice para celebrar operaciones; o bien, en periódicos de amplia circulación el domicilio
          social de la Empresa.
        </p>
      </div>
    </div>
  );
};

const WhatsAppButton = () => (
  <a href="https://wa.me/525547829794" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: "60px", height: "60px" }} />
  </a>
);

const Footer = () => (
  <footer className="footer">
    <div className="container fluid">
      <div className="row d-flex align-items-stretch">
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="contact-info text-center" style={{ textAlign: "justify" }}>
            <h5>CONTÁCTANOS</h5>
            <p style={{ color: "#fff" }}><strong>Email:</strong> contacto@aymnorte.com.mx</p>
            <p style={{ color: "#fff" }}><strong>Teléfono:</strong> +52 55 4782 9794</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CORPORATIVO</h5>
            <p>Calzada Mariano Escobedo #476,<br />Piso 12 Int. 1200 B, Anzures,<br />Miguel Hidalgo, Ciudad de México, C.P. 11590</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CEDIS</h5>
            <p>Carretera Federal México-Querétaro KM 100,<br />San Miguel de la Victoria, Jilotepec,<br />Estado de México, C.P. 54270</p>
          </div>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-md-12">
          <p style={{ color: "#fff" }}>AMNorte Aceros y Metales &copy; 2025 - Todos los derechos reservados</p>
          <p>
            <Link to='/Avisos_Privacidad'>
              <a style={{ color: "white", textDecoration: "none" }}>Aviso de Privacidad |</a>
            </Link>
            <Link to='/Terminos_y_Condiciones'>
              <a style={{ color: "white", textDecoration: "none" }}> Términos y Condiciones</a>
            </Link>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

const Aviso_Privacidad = () => {
  return (
    <div>
      <NavBar />
      <ContactForm />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Aviso_Privacidad;
